// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

/**
 * Vyjmenované hodnoty pro událost objednávky.
 */

export const ZMENA_STAV = 'ZMENA_STAV';

export const ZMENA_POBO = 'ZMENA_POBO';

/**
 * Seznam všech hodnot.
 */
export const values = [
    ZMENA_STAV,
    ZMENA_POBO
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ZMENA_STAV]: {caption: ''},
    [ZMENA_POBO]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}